export default "__VITE_ASSET__B$A67SkZ__"